"use strict";
import { useQuery } from "@tanstack/react-query";
import { TOPAZ_STATS_API_ENABLED, fetchLiveDynamicFees } from "api/topazStats/client";
import { UniverseChainId } from "features/chains/types";
const ONE_MINUTE_MS = 60 * 1e3;
const EMPTY_LIVE_FEES_MAP = /* @__PURE__ */ new Map();
export function useTopazLiveDynamicFees(chainId, enabled = true) {
  const apiEnabled = TOPAZ_STATS_API_ENABLED && enabled && chainId === UniverseChainId.Mainnet;
  const { data, isLoading, isError, isSuccess } = useQuery({
    queryKey: ["topazLiveDynamicFees", chainId],
    queryFn: async () => {
      const response = await fetchLiveDynamicFees();
      const map = /* @__PURE__ */ new Map();
      for (const pool of response.pools) {
        if (pool.poolAddress) {
          map.set(pool.poolAddress.toLowerCase(), pool);
        }
      }
      return map;
    },
    enabled: apiEnabled,
    staleTime: ONE_MINUTE_MS,
    refetchInterval: ONE_MINUTE_MS,
    retry: 1
  });
  return {
    liveFeesByAddress: data ?? EMPTY_LIVE_FEES_MAP,
    isLoading: apiEnabled && isLoading,
    isError,
    isSuccess
  };
}
